import React, { FC } from 'react';
import { VStack } from '@chakra-ui/react';
import { CardDetailsForm } from '@templates/Checkout/CardDetailsView/CardDetailsForm';
import { usePaymentDetails } from '@olo-web/domain/customer';
import { useCheckoutState } from '@olo-web/client-state';
import { CardAccordion } from './CardAccordion';
type CardDetailsViewPropTypes = {
  showEmailField: boolean;
  showSignInButton?: boolean;
};
export const CardDetailsView: FC<CardDetailsViewPropTypes> = ({
  showEmailField,
  showSignInButton = true,
}) => {
  const { data: paymentDetails } = usePaymentDetails();
  const { showCreditCardForm } = useCheckoutState();

  const hasCards = !!paymentDetails?.savedValidCards?.length;
  return (
    <VStack spacing={4} alignItems="stretch">
      {hasCards && <CardAccordion />}
      {(!hasCards || showCreditCardForm) && (
        <CardDetailsForm showEmailField={showEmailField} showSignInButton={showSignInButton} />
      )}
    </VStack>
  );
};
